import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import world from "../../../assets/images/world.png";

const ColorButton = styled(Button)(() => ({
  color: "#fff",
  width: 250,
  height: 65,
  fontWeight: 600,
  fontSize: "18px",
  textTransform: "capitalize",
  backgroundColor: "#39484E",
  border: "2px solid #39484E",
  marginRight: "2%",
  marginBottom: "4%",
  borderRadius: "30px",
  "&:hover": {
    color: "#39484E",
    backgroundColor: "#F6F4F0",
    borderColor: "#F6F4F0",
  },
}));

const About = () => {
  return (
    <Box margin={{ xs: "15% 0% 35% 0%", sm: "0% 0% 10% 0%" }}>
      <Grid container display={"flex"} alignItems={"center"}>
        <Grid
          item
          xs={12}
          sm={6}
          padding={{ xs: "25% 0% 10% 0%", sm: "4% 4% 3% 0%" }}
          marginBottom={{ xs: "0%", sm: "5%" }}
        >
          <Typography
            variant={"h3"}
            fontWeight={900}
            textAlign={"left"}
            color={"#39484E"}
            paddingBottom={"1%"}
          >
            About AIR Fund
          </Typography>

          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#000"}
            padding={{ xs: "2% 0%", sm: "2% 0% 2% 0%" }}
            lineHeight={1.5}
          >
            The African Innovation and Resilience Fund (AIR Fund) is a
            multi-year, pan-African philanthropic initiative designed to address
            critical investment gaps in Sub-Saharan Africa’s secondary cities.
            The AIR Fund steps in as a critical response to this funding void,
            ensuring that development action on macroeconomic development, just
            energy transition, employment, and innovation are not abandoned but
            rather strengthened through locally-led, impact-driven investments.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#000"}
            padding={{ xs: "2% 0%", sm: "1% 0% 2% 0%" }}
            lineHeight={1.5}
          >
            The fund exclusively provides grants to catalyze and scale solutions
            that improve economic development and climate resilience in
            secondary cities in Africa, with no expectation of financial
            returns. The fund aims to raise an initial $2 million, with grants
            disbursed every other year.
          </Typography>
          <Typography
            variant={"subtitle1"}
            fontWeight={700}
            textAlign={"left"}
            color={"#000"}
            padding={{ xs: "1% 0%", sm: "2% 0% 0% 0%" }}
            lineHeight={1.5}
          >
            The AIR Fund focuses on four strategic goals:
          </Typography>
          <Typography
            variant={"subtitle1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#000"}
            padding={{ xs: "1% 0%", sm: "1% 0% 0% 0%" }}
            lineHeight={1.5}
          >
            <Typography component={"span"} color={"#AC7551"} fontWeight={600}>
              &#10004;{" "}
            </Typography>{" "}
            Expanding economic opportunities outside of existing major cities,
          </Typography>
          <Typography
            variant={"subtitle1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#000"}
            padding={{ xs: "1% 0%", sm: "1% 0% 0% 0%" }}
            lineHeight={1.5}
          >
            <Typography component={"span"} color={"#AC7551"} fontWeight={600}>
              &#10004;{" "}
            </Typography>
            Building climate resilience,
          </Typography>
          <Typography
            variant={"subtitle1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#000"}
            padding={{ xs: "1% 0%", sm: "1% 0% 0% 0%" }}
            lineHeight={1.5}
          >
            <Typography component={"span"} color={"#AC7551"} fontWeight={600}>
              &#10004;{" "}
            </Typography>
            Supporting innovation ecosystems, and
          </Typography>
          <Typography
            variant={"subtitle1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#000"}
            padding={{ xs: "1% 0%", sm: "1% 0% 0% 0%" }}
            lineHeight={1.5}
          >
            <Typography component={"span"} color={"#AC7551"} fontWeight={600}>
              &#10004;{" "}
            </Typography>
            Leveraging AI for social good.
          </Typography>

          <Box marginTop={{ xs: "4%", sm: "4%" }}>
            <ColorButton
              size={"large"}
              variant={"contained"}
              href="/waiting-list"
            >
              Join Our Waiting List
            </ColorButton>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} margin={{ xs: "2% 0% 0% 0%", sm: "0%" }}>
          <Box
            component="img"
            height={{ xs: "", sm: "580px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={world}
            alt={"about_img"}
            sx={{
              objectFit: "cover",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default About;
